import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { addChildItem } from '@services/shoppingCartService';
import { cartQueryKey } from '@hooks/useCart/useCart';
import type { CartItemDTO, ShoppingCartDTO } from '@t/api.types';

export interface AddChildItemVariables {
  parentOfferingCode: string;
  items: CartItemDTO[];
}

interface UseAddChildItemOptions {
  onError?: (error: Error) => void;
}

export const useAddChildItem = (
  sessionId: string,
  { onError }: UseAddChildItemOptions = {}
): UseMutationResult<ShoppingCartDTO, Error, AddChildItemVariables> => {
  const queryClient = useQueryClient();
  return useMutation<ShoppingCartDTO, Error, AddChildItemVariables>({
    mutationFn: ({ parentOfferingCode, items }) => addChildItem(sessionId, parentOfferingCode, items),
    onSuccess: (cart) => queryClient.setQueryData<ShoppingCartDTO>(cartQueryKey(sessionId), cart),
    onError,
  });
};
